import React from "react";
import { Link } from "react-router-dom";

function Pricing() {
  return (
    <div className="container py-5">
      <div className="row align-items-center">
        <div className="col-12 col-md-5 mb-4 mb-md-0">
          <h1 className="mb-3 fs-2">Unbeatable pricing</h1>
          <p>
            We pioneered the concept of discount broking and price transparency
            in India. Flat fees and no hidden charges.
          </p>

          <Link to="/pricing" style={{ textDecoration: "none" }}>
            See Pricing →
          </Link>
        </div>

        <div className="col-12 col-md-7">
          <div className="row text-center">
            <div className="col-12 col-sm-6 p-3 border">
              <h1 className="mb-3">₹0</h1>
              <p>Free equity delivery and direct mutual funds</p>
            </div>

            <div className="col-12 col-sm-6 p-3 border">
              <h1 className="mb-3">₹20</h1>
              <p>Intraday and F&O</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
